import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow, PreviewImage } from "../../components/index";
import { MediaChannel } from "../../forms/MediaChannelForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const MediaChannelTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: MediaChannelTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [deleteMediaChannelModalShowing, setDeleteMediaChannelModalShowing] =
        useState(false);
    const [deleteMediaChannelName, setDeleteMediaChannelName] = useState("");
    const [deleteMediaChannelId, setDeleteMediaChannelId] = useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>
                            {" "}
                            <TableHeader onClick={() => onOrderBy("id")}>
                                {trans("ID")}
                            </TableHeader>
                        </th>
                        <th>{trans("Name")}</th>
                        <th>
                            <TableHeader onClick={() => onOrderBy("slug")}>
                                {trans("Slug")}
                            </TableHeader>
                        </th>
                        <th>
                            <TableHeader onClick={() => onOrderBy("order")}>
                                {trans("Order")}
                            </TableHeader>
                        </th>
                        <th>{trans("Image")}</th>
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={"100%"}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={"100%"}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr>
                                    <td>{item.id}</td>
                                    <td>{item.name}</td>
                                    <td>{item.slug}</td>
                                    <td>{item.order}</td>
                                    <td>
                                        {item.thumbnail ? (
                                            <PreviewImage
                                                src={item.thumbnail}
                                            />
                                        ) : (
                                            trans("No image provided")
                                        )}
                                    </td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteMediaChannelId(
                                                    item.uuid
                                                );
                                                setDeleteMediaChannelModalShowing(
                                                    true
                                                );
                                                setDeleteMediaChannelName(
                                                    item.name
                                                );
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteMediaChannelModalShowing && (
                <Modal
                    visible={deleteMediaChannelModalShowing}
                    onClose={() => {
                        setDeleteMediaChannelModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h3>
                            {trans(
                                "You are about delete: {deleteMediaChannelName}",
                                {
                                    deleteMediaChannelName,
                                }
                            )}
                        </h3>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="secondary"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteMediaChannelModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteMediaChannelId).then(() => {
                                    setDeleteMediaChannelModalShowing(false);
                                });
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface MediaChannelTableProps {
    items: MediaChannel[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<MediaChannel[]>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: ({ value }) => void;
}

export default MediaChannelTable;
